// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { tableCellClasses } from '@mui/material/TableCell';
import { rem } from '../../tokens/conversions';
import { tableColors } from './tableColors';
export var Table = function(mode) {
    var c = tableColors(mode);
    var override = {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    overflow: 'auto'
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: _define_property({}, "& .".concat(tableCellClasses.root), {
                    fontWeight: 400,
                    color: c.headText
                })
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: c.hover.background
                    },
                    '&.Mui-selected': {
                        backgroundColor: c.selected.background,
                        '&:hover': {
                            backgroundColor: c.selected.background
                        }
                    },
                    '&.Mui-disabled': _define_property({
                        backgroundColor: c.disabled.background
                    }, "& .".concat(tableCellClasses.root), {
                        color: c.disabledText
                    }),
                    '&.active': {
                        backgroundColor: c.active.background
                    }
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: "".concat(rem(1), " solid ").concat(c.border),
                    padding: rem(12),
                    minHeight: rem(60),
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    fontWeight: 500,
                    color: c.text,
                    verticalAlign: 'middle'
                },
                sizeSmall: {
                    padding: "".concat(rem(4), " ").concat(rem(8)),
                    minHeight: rem(32),
                    fontSize: rem(12),
                    lineHeight: rem(16)
                },
                head: {
                    color: c.headText
                }
            },
            variants: [
                {
                    props: {
                        disableBottomBorder: true
                    },
                    style: {
                        borderBottom: 'none'
                    }
                }
            ]
        }
    };
    return override;
};

//# sourceMappingURL=Table.js.map